__turbopack_context__.v({
  "table": "yB-SkW_table",
  "tableWrapper": "yB-SkW_tableWrapper",
});
